import Autocomplete from '@mui/material/Autocomplete';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';

type Props<TOption> = {
	getOptionId: (option: TOption) => string | number;
	getOptionLabel: (option: TOption) => string;
	label: string;
	loading?: boolean;
	onChange: (value: TOption[]) => void;
	onInputChange?: (value: string) => void;
	options: TOption[];
	value: TOption[];
};

export const ReportingMultiSelect = <TOption,>({
	getOptionId,
	getOptionLabel,
	label,
	loading = false,
	onChange,
	onInputChange,
	options,
	value,
}: Props<TOption>) => {
	return (
		<Autocomplete
			multiple
			disableClearable
			loading={loading}
			options={options}
			value={value}
			getOptionLabel={getOptionLabel}
			isOptionEqualToValue={(option, selectedOption) => getOptionId(option) === getOptionId(selectedOption)}
			onChange={(_, selectedOptions) => onChange(selectedOptions)}
			onInputChange={(_, inputValue, reason) => {
				if (!onInputChange) {
					return;
				}

				if (reason !== 'input' && reason !== 'clear') {
					return;
				}

				onInputChange(inputValue);
			}}
			renderInput={(params) => <TextField {...params} label={label} />}
			renderTags={(tagValue, getTagProps) =>
				tagValue.map((option, index) => (
					<Chip
						{...getTagProps({ index })}
						key={getOptionId(option)}
						label={getOptionLabel(option)}
						size='small'
					/>
				))
			}
		/>
	);
};
